import React from 'react';
export function BravoFeature() {
  return <section className="mx-auto mt-20 max-w-5xl px-6 md:mt-24" data-id="element-10" data-mp="1kksudjybwiot">
      <div className="grid grid-cols-1 items-center gap-10 md:grid-cols-2 md:gap-12" data-id="element-11" data-mp="1km2qpcluq5wf">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/37b0ed09-8f9b-4893-9c99-b8938e6cbdc6.jpg" alt="Katie Maloney and Tom Schwartz exchanging vows in the forest ceremony site" className="aspect-[4/3] w-full object-cover" data-id="element-12" data-mp="1zafli697dipc" />
        <div data-id="element-13" data-mp="23brhctio705z">
          <p className="font-sans text-[9px] font-medium uppercase tracking-[0.35em] text-ink/60" data-id="element-14" data-mp="23c10bx5as726">
            As seen on Bravo
          </p>
          <h2 className="mt-3 font-display text-3xl font-medium uppercase leading-tight tracking-[0.04em] text-ink md:text-[2.1rem]" data-id="element-15" data-mp="2i80ffrqtr7gt">
            Katie Maloney &amp; Tom Schwartz
          </h2>
          <p className="mt-5 font-body text-[14px] leading-relaxed text-ink/80" data-id="element-16" data-mp="nvaif155ti57">
            When the Vanderpump Rules cast needed a wedding that could hold 69 crew members and
            still feel private, they chose Twenty Mile House. Lisa Vanderpump officiated in our
            forest clearing. Dinner was served in the gardens under custom lighting, and the
            weekend played out across two episodes of the Bravo finale.
          </p>
          <p className="mt-4 font-body text-[14px] leading-relaxed text-ink/80" data-id="element-17" data-mp="1en5szqjwm497">
            The same team, the same property, the same all-inclusive weekend is what we build for
            every couple who books here.
          </p>
        </div>
      </div>
    </section>;
}